import { render } from "./UIdleTimer.vue?vue&type=template&id=3247d85e"
import script from "./UIdleTimer.vue?vue&type=script&lang=ts"
export * from "./UIdleTimer.vue?vue&type=script&lang=ts"
script.render = render

export default script